import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiRating: {
            styleOverrides: {
                root: {
                    color: designTokens.color.yellow.medium.value,
                    gap: '2px',
                },
                icon: {
                    '.MuiSvgIcon-root': {
                        stroke: designTokens.color.yellow.medium.value,
                        strokeWidth: '1px',
                        strokeLinejoin: 'round',
                    },
                },
                iconFilled: {
                    color: designTokens.color.yellow.medium.value,
                },
                iconEmpty: {
                    color: designTokens.color.shade.white.value,
                },
                sizeMedium: {
                    fontSize: '20px',
                },
                sizeSmall: {
                    fontSize: '16px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=ratingTheme.js.map